import React from 'react';

export const SvgFiberManualRecord = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M12 4a8 8 0 100 16 8 8 0 000-16z" fill="currentColor" />
  </svg>
);
